import { lazy, Suspense, useEffect, useState } from "react";
/// Components

import Index from "./jsx";
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
import { adminloginApi } from "./services/AuthService";

import "./css/style.css";
import Error404 from "./jsx/pages/Error404";
import { checkRoute, useCheckRoute } from "./utils/invalidRoute";
import { jwtDecode } from "jwt-decode";
import PrivateRoute from "./jsx/components/PrivateRoute/PrivateRoute";
// import { useNavigate } from "react-router-dom";
const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

// const TokenKey = localStorage.getItem("access_token_admin");
// console.log("TokenKey===>",TokenKey)

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  let locationn = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  console.log("queryParams===>", queryParams)
  const Usertoken = queryParams.get("token");
  const Usertype = queryParams.get("type");
  const user_category_main = queryParams.get("user_category_main");
  const category_type = queryParams.get("category_type");
  const id = queryParams.get("id");
  const schemeSecretkey = queryParams.get("secret_key");
  const bookingkey = queryParams.get("booking_key") === "true";

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isTokenChecked, setIsTokenChecked] = useState(false);
  const [updateToken, setUpdateToken] = useState("");
  useEffect(() => {
    const formMatch = window.location.pathname.match(
      /^\/grant-scheme\/form\/(.+)$/
    );
    const descMatch = window.location.pathname.match(
      /^\/grant-scheme\/description\/(.+)$/
    );
    const isGrantSchemedescMatch =
      window.location.pathname.match(/^\/grant-scheme/);
    const token = localStorage.getItem("access_token_admin");
    setUpdateToken(token);
    const isUserAuthenticated = !!token;

    if (!isUserAuthenticated) {
      const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
      const externalUrl = `${ukWebsiteUrl}/login_email`;
      if (formMatch || descMatch || isGrantSchemedescMatch) {
        window.location.href = externalUrl;
        return;
      }
    }

    // Check if token and type are present in the URL
    if (Usertoken && Usertype === "user") {
      // Set the token in localStorage
      localStorage.setItem("access_token_admin", Usertoken);
      localStorage.setItem("user_type", Usertype);
      localStorage.setItem("user_category_main", user_category_main);
      localStorage.setItem("category_type", category_type)
      localStorage.setItem("id", id);
      localStorage.removeItem("login_Details");
      // Set isAuthenticated to true
      setIsAuthenticated(true);
      // Redirect to the profile page
      // schemeSecretkey === null ? navigate('/profile') :  navigate(`/grant-scheme/form/${schemeSecretkey}`)// Adjust the route as per your profile page
      // Updated condition
      if (bookingkey === true) {
        const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
        const externalUrl = `${ukWebsiteUrl}/venue-slot-booking-details`;
        window.location.href = externalUrl;
      } else if (
        !schemeSecretkey ||
        schemeSecretkey === "null" ||
        bookingkey === false ||
        bookingkey === null
      ) {
        navigate("/profile");
      } else {
        navigate(`/grant-scheme/form/${schemeSecretkey}`);
      }
    } else {
      // Check localStorage for the existing token
      const token = localStorage.getItem("access_token_admin");
      setIsAuthenticated(!!token);
    }
    setIsTokenChecked(true);
  }, [Usertoken, Usertype, navigate]);

  // useEffect(() => {
  //   alert("use")
  //   const token = localStorage.getItem("access_token_admin");
  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token);
  //       const isExpired = decoded.exp < Date.now() / 1000;
  //       if (isExpired) {
  //         localStorage.clear(); // or just remove token
  //         navigate("/admin-login");
  //       }
  //     } catch (error) {
  //       console.error("Invalid token");
  //       localStorage.clear();
  //       navigate("/admin-login");
  //     }
  //   }
  // }, []);

  // let routesBlog = (
  //   <Routes>
  //     <Route path="/" element={<Login apifun={adminloginApi} />} />
  //     <Route path="/admin-login" element={<Login apifun={adminloginApi} />} />
  //     <Route path="/page-register" element={<SignUp />} />
  //     <Route path="/page-forgot-password" element={<ForgotPassword />} />
  //     {useCheckRoute() && <Route path="/*" element={<Error404 />} />}

  //   </Routes>
  // );

  // if (!isTokenChecked) {
  //   // Still checking authentication — show loader
  //   return (
  //     <div className="vh-100">
  //       <div id="preloader">
  //         <div className="sk-three-bounce">
  //           <div className="sk-child sk-bounce1"></div>
  //           <div className="sk-child sk-bounce2"></div>
  //           <div className="sk-child sk-bounce3"></div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isAuthenticated) {
  //   //console.log("isAuthenticated",isAuthenticated);
  //   return (
  //     <>
  //       <Suspense
  //         fallback={
  //           <div id="preloader">
  //             <div className="sk-three-bounce">
  //               <div className="sk-child sk-bounce1"></div>
  //               <div className="sk-child sk-bounce2"></div>
  //               <div className="sk-child sk-bounce3"></div>
  //             </div>
  //           </div>
  //         }
  //       >
  //         <Index />
  //       </Suspense>
  //     </>
  //   );
  // } else {
  //   return (
  //     <div className="vh-100">
  //       <Suspense
  //         fallback={
  //           <div id="preloader">
  //             <div className="sk-three-bounce">
  //               <div className="sk-child sk-bounce1"></div>
  //               <div className="sk-child sk-bounce2"></div>
  //               <div className="sk-child sk-bounce3"></div>
  //             </div>
  //           </div>
  //         }
  //       >
  //          {routesBlog}
  //       </Suspense>
  //     </div>
  //   );
  // }
  return (
    <Suspense fallback="Loading">
      <Routes>
        {/* Public routes */}
        {/*  */}
        <Route path="/admin-login" element={<Login apifun={adminloginApi} />} />
        <Route path="/page-register" element={<SignUp />} />
        <Route path="/page-forgot-password" element={<ForgotPassword />} />

        {/* Private routes */}
        {/* <Route
          path="/*"
          element={
            <PrivateRoute>
              <Index />
            </PrivateRoute>
          }
        /> */}
        <Route
          element={<PrivateRoute />}
        >
          <Route path="/*" element={<Index />} />
        </Route>

        {/* 404 fallback */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
}

export default withRouter(App);
